import { render, staticRenderFns } from "./CategoryEntries.vue?vue&type=template&id=3656d22e&scoped=true"
import script from "./CategoryEntries.vue?vue&type=script&lang=js"
export * from "./CategoryEntries.vue?vue&type=script&lang=js"
import style0 from "./CategoryEntries.vue?vue&type=style&index=0&id=3656d22e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3656d22e",
  null
  
)

export default component.exports